exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Line-Info {\r\n    border-bottom: 1px solid #DDD;\r\n    font-size: 20px;\r\n    height: 12px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n#order-confirmation ul li input[type=radio] {\r\n    position: relative !important;\r\n    visibility: visible !important;\r\n}\r\n\r\n.modal-inline-radio,\r\n#order-confirmation ul li label{\r\n    display: inline-block !important;\r\n    padding-left: 15px;\r\n}\r\n\r\n.radio-recommendation-wrapper{\r\n    padding-top: 15px !important;\r\n}\r\nul.radio-recommendation-wrapper{\r\n    padding: 0px;\r\n    margin: 0px;\r\n}\r\n\r\n.radio-recommendation-wrapper > li{\r\n    height: 40px ;\r\n}\r\n\r\n.radio-recommendation-wrapper > li label{\r\n    position: absolute !important;\r\n    padding-left: 60px !important;\r\n}\r\n\r\n.visible-hidden{\r\n    position: relative !important;\r\n    visibility: visible !important;\r\n}\r\n\r\n#order-confirmation ul li .check {\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/path-recommendation/path-recommendation.component.css
// module id = ../../../../../src/app/path-recommendation/path-recommendation.component.css
// module chunks = main